"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const css_mediaquery_1 = __importDefault(require("css-mediaquery"));
function createMatchMedia(width) {
  return query => ({
    matches: css_mediaquery_1.default.match(query, {
      width
    }),
    addListener: () => {},
    removeListener: () => {}
  });
}
exports.default = createMatchMedia;